export default __webpack_public_path__ + "static/AvenirLTStd-HeavyOblique-db27d20ab4eb36cdb5e57de4ce3b88ac.woff";